import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { initDarkModeSync, initGlowColorSync } from './store/useStore';

// Sync dark class and glow CSS var to store for the lifetime of the app
initDarkModeSync();
initGlowColorSync();

const root = document.getElementById('root');
if (!root) throw new Error('#root element not found');

createRoot(root).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
